<template>
  <div>
    <div class="container" id="main">
      <div class="row justify-content-center">
        <div id="logohead" class="col-12 col-lg-8">
          <img :src="logo" />
        </div>
      </div>
      <div class="row justify-content-center">
        <div
          id="content"
          class="col-12 col-lg-8"
          v-bind:style="{ backgroundColor: '#F0F0F0', border: '1px solid #ccc' }"
        >
          <p
            style="font-size:18px; line-height: 30px;margin-bottom: 30px;"
          >Mit Mi_SecMail geben wir Ihnen die Möglichkeit, verschlüsselte Emails zu versenden und somit die Inhalte Ihrer Mails gegen ungewollte Zugriffe Dritter zu schützen.</p>
          <iframe
            style="width:100%"
            height="400"
            src="https://www.youtube.com/embed/61C4-fk5QPc"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "Landingpage",
  components: {
    //HelloWorld
  },
  computed: {
    logo: function() {
        return (
          window.location.protocol +
          "//" +
          window.location.host +
          "/logos/logo_misoft.jpg"
        );

    },
  }
};
</script>
<style scoped>
@media screen {
  /*table {
    border-collapse: collapse;
    border-spacing: 0;
  }*/

  #main {
    margin-top: 40px;
  }

  #logohead {
    padding: 0px;
    margin-bottom: 20px;
  }
  #globalerror {
    padding: 0px;
    margin-bottom: 0px;
  }

  #footer {
    padding: 0px;
    margin-top: 10px;
  }

  #content {
    margin-bottom: 100px;
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  }

  h1 {
    font-size: 20px;
    margin-bottom: 30px;
  }

  h2 {
    font-size: 15px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  /*
  ul {
    margin-left: 20px;
  }
  p {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  td {
    padding-bottom: 7px;
  }
  li {
    margin-bottom: 7px;
  }
  li a {
    text-decoration: none;
    font-weight: bold;
  }

  .tablekey {
    font-weight: bold;
  }

  hr {
    display: block;
    height: 1px;
    border: 0;
    margin: 1em 0;
    padding: 0;
    margin-top: 20px;
  }
  .tablevalue {
    padding-left: 10px;
  }*/
}
</style>
